import { AuthService } from "../../service/AuthService.ts";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
const initialState = {
    token: "",
    loading: false,
    userInfo: {},
    signInForm: {},
    userEmail: ""
};
const action = {
    login: createAsyncThunk("auth/login", async (payload, thunkAPI) => {
        try {
            const response = await AuthService.login(thunkAPI, payload);
            return response.data;
        }
        catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }),
    signup: createAsyncThunk("auth/signup", async (payload, thunkAPI) => {
        return (await AuthService.signup(thunkAPI, payload.data)).data;
    }),
    completeEnrolement: createAsyncThunk("auth/completeEnrollment", async (payload, thunkAPI) => {
        return (await AuthService.completeEnrolement(thunkAPI, payload.data))
            .data;
    }),
    // invite: createAsyncThunk(
    //     "auth/invite",
    //     async (payload: ActionType<CreateInviteRequest>, thunkAPI) => {
    //         return (await AuthService.invite(thunkAPI, payload.data)).data;
    //     }
    // ),
    reset: createAsyncThunk("auth/reset", async (payload, thunkAPI) => {
        return (await AuthService.reset(thunkAPI, payload.data)).data;
    }),
    resetPassword: createAsyncThunk("auth/reset-password", async (payload, thunkAPI) => {
        return (await AuthService.resetPassword(thunkAPI, payload?.data)).data;
    }),
    changePassword: createAsyncThunk("auth/change-password", async (payload, thunkAPI) => {
        return (await AuthService.changePassword(thunkAPI, payload.data)).data;
    }),
};
const slice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        setToken(state, { payload }) {
            state.token = payload;
        },
        setLoading(state, { payload }) {
            state.loading = payload;
        },
        setUserInfo(state, { payload }) {
            state.userInfo = payload;
        },
        setUserEmail(state, { payload }) {
            state.userEmail = payload;
        }, setCoreAuthState: (state, { payload }) => {
            state.token = payload.token;
            state.userInfo = payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(action.login.pending, (state) => {
            state.loading = true;
        })
            .addCase(action.login.fulfilled, (state, action) => {
            const response = action.payload;
            state.loading = false;
            state.token = response.token;
            if (response.responseCode === "00") {
                state.userInfo = response;
                // action.meta.arg.onSuccess?.(action.payload);
            }
            else {
                // action.meta.arg.onError?.(action.payload);
            }
        })
            // .addCase(action.invite.pending, (state) => {
            //     state.loading = true;
            // })
            // .addCase(action.invite.fulfilled, (state, action) => {
            //     const response = action.payload as InviteResponse;
            //     state.loading = false;
            //     if (response.responseCode === "00")
            //         action.meta.arg.onSuccess?.(action.payload);
            //     else {
            //         action.meta.arg.onError?.(action.payload);
            //     }
            // })
            .addCase(action.signup.pending, (state) => {
            state.loading = true;
        })
            .addCase(action.signup.fulfilled, (state, action) => {
            const response = action.payload;
            state.loading = false;
            if (response.responseCode === "00") {
                action.meta.arg.onSuccess?.(action.payload);
            }
            else {
                action.meta.arg.onError?.(action.payload);
            }
        })
            .addCase(action.completeEnrolement.pending, (state) => {
            state.loading = true;
        })
            .addCase(action.completeEnrolement.fulfilled, (state, action) => {
            const response = action.payload;
            state.loading = false;
            if (response.responseCode === "00")
                action.meta.arg.onSuccess?.(action.payload);
            else {
                action.meta.arg.onError?.(action.payload);
            }
        })
            .addCase(action.reset.pending, (state) => {
            state.loading = true;
        })
            .addCase(action.reset.fulfilled, (state, action) => {
            const response = action.payload;
            state.loading = false;
            if (response.responseCode === "00")
                action.meta.arg.onSuccess?.(action.payload);
            else {
                action.meta.arg.onError?.(action.payload);
            }
        })
            .addCase(action.resetPassword.pending, (state) => {
            state.loading = true;
        })
            .addCase(action.resetPassword.fulfilled, (state, action) => {
            const response = action.payload;
            state.loading = false;
            if (response.responseCode === "00")
                action.meta.arg.onSuccess?.(action.payload);
            else {
                action.meta.arg.onError?.(action.payload);
            }
        })
            .addCase(action.changePassword.pending, (state) => {
            state.loading = true;
        })
            .addCase(action.changePassword.fulfilled, (state, action) => {
            const response = action.payload;
            state.loading = false;
            if (response.responseCode === "00")
                action.meta.arg.onSuccess?.(action.payload);
            else {
                action.meta.arg.onError?.(action.payload);
            }
        });
    },
});
export const auth = {
    reducer: slice.reducer,
    action: action,
    mutation: slice.actions,
};
